import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [{ path: "wallet", lazy: page(() => import("./WalletPage")), handle: shows("wallet") }],
};
